<template>
  <div class="NavFavouriteItem flex">
    <figure class="relative w-1/4">
      <a :href="listing.path">
        <img :src="listing.thumbUrl" :alt="listing.title" class="rounded-lg" />
      </a>
    </figure>
    <div class="relative w-3/4">
      <div class="flex-1 ml-4 overflow-x-hidden">
        <div class="absolute right-0" v-if="!currentUser">
          <button @click="$emit('remove')" class="fa-2x ml-auto">
            <i class="fal fa-times-circle"></i>
          </button>
        </div>

        <div class="flex-1">
          <h1 v-visit="listing.path" class="text-md">
            <!-- Turned off Turbo here because it broke components loading on iOS -->
            <a class="no-decorate-link" data-turbo="false" :href="listing.path">{{
              listing.title | truncate(23, "...")
            }}</a>
          </h1>
          <h2 v-visit="listing.artist.path" class="text-sm">
            <!-- Turned off Turbo here because it broke components loading on iOS -->
            <a class="text-xs font-bold text-black no-decorate-link" data-turbo="false" :href="listing.artist.path">{{
              listing.artist.name
            }}</a>
          </h2>
          <h3 class="text-base text-black my-3">{{ listing.total.format }}</h3>

          <AddCartBtn
            containerClass="mb-2"
            v-if="!listing.sold && !listing.availableFromDate"
            :mode="availabilityMode"
            :listingId="listing.id"
            :checkoutPath="checkoutPath"
            viewCartClass="btn-sm btn-primary rounded-lg"
            addCartClass="btn-sm btn-default-primary rounded-lg"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddCartBtn from "@/components/Listing/AddCartBtn.vue"

export default {
  name: "Nav.FavouriteItem",
  props: {
    listing: {
      type: Object,
      required: true,
    },
    checkoutPath: {
      type: String,
      required: true,
    },
  },
  components: {
    AddCartBtn,
  },
  computed: {
    availabilityMode() {
      if (!this.listing.reprint && (this.listing.dispatchFromDate || this.listing.artist.holidayMode)) {
        return "modal"
      }
    },
  },
}
</script>

<style>
.NavFavouriteItem__img-dimension {
  width: 100px;
  height: 100px;
}
</style>
